import React from 'react'
import type { IOccurrencesAssociatedOrgans, ResponseProps } from '../interfaces'
import { createState, useState, type State } from '@hookstate/core'
import {
  getOccurrencesAssociatedOrgansByType,
  getOccurrencesAssociatedOrgansByCircunstance,
  getOccurrencesAssociatedOrgansByOccurrenceType,
} from '../components/QualifiersCharts/Organs/services'

interface IOccurrencesAssociatedOrgansProps {
  readonly occurrencesAssociatedOrgans: IOccurrencesAssociatedOrgans
  readonly loadingCharts: boolean
}

const occurrencesAssociatedOrgansProps: Readonly<ResponseProps> = {
  item: null,
  value: null,
  total: null,
}

const occurrencesAssociatedOrgansDefault: Readonly<IOccurrencesAssociatedOrgans> =
  {
    occurrencesAssociatedOrgansByType: occurrencesAssociatedOrgansProps,
    occurrencesAssociatedOrgansByCircunstance: occurrencesAssociatedOrgansProps,
    occurrencesAssociatedOrgansByOccurrenceType: occurrencesAssociatedOrgansProps,
  }

const store = createState<Readonly<IOccurrencesAssociatedOrgansProps>>({
  occurrencesAssociatedOrgans: occurrencesAssociatedOrgansDefault,
  loadingCharts: true,
})

interface getAllsAssociatedOrgansDataProps {
  readonly startDate: string
  readonly finishDate: string
  readonly actionTakenId?: number | null
  readonly auxiliaryOrgansId?: number | null
}

export default function useManagementQualifiersOrgansState() {
  const occurrencesAssociatedOrgans: State<
    Readonly<IOccurrencesAssociatedOrgans>
  > = useState(store.occurrencesAssociatedOrgans)
  const loadingCharts = useState(store.loadingCharts)

  async function getAssociatedOrgansStats({
    startDate,
    finishDate,
    actionTakenId,
    auxiliaryOrgansId
  }: getAllsAssociatedOrgansDataProps) {
    const params = {
      startDate,
      finishDate,
      actionTakenId,
      auxiliaryOrgansId
    }
    loadingCharts.set(true)

    Promise.all([
      getOccurrencesAssociatedOrgansByType(params).then((response) => {
        occurrencesAssociatedOrgans.occurrencesAssociatedOrgansByType.set(response)
      }),
      getOccurrencesAssociatedOrgansByCircunstance(params).then((response) => {
        occurrencesAssociatedOrgans.occurrencesAssociatedOrgansByCircunstance.set(
          response
        )
      }),
      getOccurrencesAssociatedOrgansByOccurrenceType(params).then(
        (response) => {
          occurrencesAssociatedOrgans.occurrencesAssociatedOrgansByOccurrenceType.set(
            response
          )
        }
      ),
    ]).finally(() => {
      loadingCharts.set(false)
    })
  }

  return {
    occurrencesAssociatedOrgans: () => occurrencesAssociatedOrgans,
    fetchAllAssociatedOrgansData: async ({
      actionTakenId,
      finishDate,
      startDate,
      auxiliaryOrgansId,
    }) =>
      getAssociatedOrgansStats({
        actionTakenId,
        finishDate,
        startDate,
        auxiliaryOrgansId,
      }),
    loadingCharts: loadingCharts,
  }
}